import styled from 'styled-components';
import { ColumnHeader } from '../components/common';

export const HeaderRowWrapper = styled.div<{ $borderRadius?: string; $backgroundColor?: string }>`
	display: flex;
	background-color: ${props => props.$backgroundColor ?? props.theme.colors.grey[200]};
	border-radius: ${props => props.$borderRadius ?? ''};

	width: 100%;
	overflow: hidden;

	.column-drag {
		border: 2px solid red;
		${ColumnHeader} {
			box-shadow: 1px 3px 20px rgba(0, 0, 0, 0.25);
		}
	}
`;
